<template>
    <div>
        <vx-card>
            <vs-tabs>
                <vs-tab :label="$t('menuOrganization.personalInformation')">
                    <div>
                        <div class="vx-row">
                            <div class="vx-col md:w-3/4 w-full">
                                <div class="flex items-end mt-6 mb-3">
                                    <feather-icon icon="SidebarIcon" class="mr-2" svgClasses="w-6 h-6"/>
                                    <span class="leading-none fsz font-bold">Đơn vị - Bộ phận</span>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.branch') }} </label>
                                        <span class="text-danger">*</span>
                                        <v-select class="" v-model="branchModel" :clearable="false"
                                                  :options="branchOptions"
                                                  data-vv-validate-on="blur" v-validate="'required'"
                                                  name="branch">
                                            <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2" v-if="!isCreateDepartment">
                                        <label class="vs-input--label">{{ $t('menuOrganization.department') }}</label>
                                        <v-select class="" v-model="departmentModel" :clearable="false"
                                                  :options="departmentOptions" data-vv-validate-on="blur">
                                            <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                        </v-select>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2"
                                         v-if="isCreateDepartment">
                                        <label class="vs-input--label">{{
                                                $t('menuOrganization.createDepartment')
                                            }}</label>
                                        <vs-input class="w-full" v-model="departmentName" name="departmentName"/>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-6">
                                        <vs-button class="mt-2" type="border" v-if="!isCreateDepartment && !employeeId"
                                                   @click="createDepartment">{{ $t('button.addNew') }}
                                        </vs-button>
                                        <vs-button class="mt-2" type="border"
                                                   v-if="isCreateDepartment"
                                                   @click="saveDepartment">
                                            {{ $t('button.save') }}
                                        </vs-button>
                                        <vs-button class="ml-4 mt-2" type="border"
                                                   v-if="isCreateDepartment"
                                                   @click="cancelCreateDeparment">{{ $t('button.back') }}
                                        </vs-button>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.employeeType') }}</label>
                                        <span class="text-danger">*</span>
                                        <v-select class="" v-model="employeeTypeModel" :clearable="false"
                                                  :options="employeeTypeOptions" data-vv-validate-on="blur"
                                                  v-validate="'required'" name="type">
                                            <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('type') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.location') }}</label>
                                        <v-select class="w-full" v-model="selectedDuty" :options="dutyOptions"
                                                  name="position" :clearable="false"></v-select>
                                        <span class="text-danger text-sm">{{ errors.first('position') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2" v-if="selectedDutyValue == 8">
                                        <label class="vs-input--label">{{ $t('menuOrganization.location') }}</label>
                                        <vs-input v-model="selectedDutyInputValue" class="w-full"></vs-input>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.salary') }} </label>
                                        <span class="text-danger">*</span>
                                        <vs-input class="w-full" v-model="employeeInfo.salary"
                                                  v-validate="'required|alpha_num'" name="salary" type="number"/>
                                        <span class="text-danger text-sm">{{ errors.first('salary') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">Chức vụ</label>
                                        <!-- <span class="text-danger tect-sm">*</span> -->
                                        <v-select multiple v-model="selectedPositions" :options="positionOptions"
                                                  :clearable="false" name="position">
                                            <span slot="no-options"> {{ $t('root.noRowsToShow') }} </span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('position') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">Mã liên kết</label>
                                        <vs-input class="w-full" v-model="employeeInfo.linkCode"
                                                  name="linkCode" />
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/4 w-full">
                                <div class="flex items-end mt-6 mb-3">
                                    <feather-icon icon="SmileIcon" class="mr-2" svgClasses="w-6 h-6"/>
                                    <span class="leading-none fsz font-bold">Avatar</span>
                                </div>
                                <div class="avatar-col cursor-pointer m-auto upload-image" @click="editAvatar">
                                    <div class="img-container mb-4 m-auto" @mouseover="showEdit = true"
                                         @mouseout="showEdit = false">
                                        <img v-if="!img" :src="userInfo.avatar" class="rounded w-full" alt="">
                                        <img v-else :src="img" class="rounded w-full" alt="">
                                        <!-- <div class="component custom-edit m-auto text-white" v-show="showEdit">
                                            <feather-icon icon="Edit3Icon" style="width:2rem"></feather-icon>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <vs-divider class="mt-8 mb-0"/>

                        <div class="vx-row">
                            <div class="vx-col md:w-3/4">
                                <div class="flex items-end mt-8 mb-3">
                                    <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-6 h-6"/>
                                    <span class="leading-none fsz font-bold">Lý lịch - Liên hệ</span>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.employeeCode') }}
                                        </label>
                                        <span class="text-danger">*</span>
                                        <vs-input class="w-full" :disabled="isUpdate"
                                                  v-model="employeeInfo.employeeCode"
                                                  v-validate="'required|max:20'" name="employeeCode"/>
                                        <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.startWork') }} </label>
                                        <span class="text-danger">*</span>
                                        <datepicker :language="vn" :disabled-dates="disabledDates"
                                                    :format="'dd/MM/yyyy'"
                                                    v-model="employeeInfo.startWork" :highlighted="highlightedFn"
                                                    data-vv-validate-on="input" v-validate="'required'"
                                                    name="startWork">
                                        </datepicker>
                                        <span class="text-danger text-sm">{{ errors.first('startWork') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2" v-show="isUpdate">
                                        <vs-checkbox v-model="employeeInfo.enabled" class="mb-1 mt-8">
                                            {{ $t('menuOrganization.working') }}
                                        </vs-checkbox>
                                    </div>
                                    <div class="vx-col md:w-1/6 w-full mt-2">
                                        <vs-checkbox v-model="employeeInfo.departmentType"
                                                     v-if="isShowManagerDepartment"
                                                     class="mb-1 mt-4">
                                            {{ $t('menuOrganization.Manager') }}
                                        </vs-checkbox>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.lastName') }} </label>
                                        <span class="text-danger">*</span>
                                        <vs-input class="w-full" v-model="lastNameModel" v-validate="'required|max:20'"
                                                  name="lastName"/>
                                        <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.firstName') }}</label>
                                        <span class="text-danger">*</span>
                                        <vs-input class="w-full" v-model="firstNameModel" v-validate="'required|max:20'"
                                                  name="firstName"/>
                                        <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
                                    </div>

                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <vx-input-group>
                                            <label class="vs-input--label">{{ $t('menuOrganization.userName') }}</label>
                                            <span class="text-danger">*</span>
                                            <vs-input class="w-full" v-model="userNameModel"
                                                      @input="checkLengthUserName"
                                                      v-validate="'required|max:50'" :disabled="isUpdate"
                                                      name="userName"/>
                                            <template v-if="!isUpdate" slot="append">
                                                <div class="append-text btn-addon mt-6">
                                                    <vs-button :disabled="isMaxLength" @click="checkUserName(true)"
                                                               color="primary" style="height: 37px">
                                                        {{ $t('button.check') }}
                                                    </vs-button>
                                                </div>
                                            </template>
                                        </vx-input-group>
                                        <span class="text-danger text-sm">{{ errors.first('userName') }}</span>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.birthday') }}</label>
                                        <span class="text-danger">*</span>
                                        <datepicker :language="vn" :disabled-dates="disabledDates"
                                                    :format="'dd/MM/yyyy'"
                                                    v-model="employeeInfo.birthday" :highlighted="highlightedFn"
                                                    data-vv-validate-on="input" v-validate="'required'" name="birthday">
                                        </datepicker>
                                        <span class="text-danger text-sm">{{ errors.first('birthday') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.gender') }} </label>
                                        <span class="text-danger">*</span>
                                        <v-select class="" v-model="genderModel" :clearable="false"
                                                  :options="genderOptions"
                                                  data-vv-validate-on="blur" v-validate="'required'" name="gender">
                                            <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">Email </label>
                                        <span class="text-danger">*</span>
                                        <vs-input class="w-full" v-model="employeeInfo.email"
                                                  v-validate="'required|email'"
                                                  name="email"/>
                                        <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/4">
                                <div class="flex items-end mt-8 mb-3 w-full">
                                    <feather-icon icon="CameraIcon" class="mr-2" svgClasses="w-6 h-6"/>
                                    <span class="leading-none fsz font-bold">{{
                                            $t('menuOrganization.faceData')
                                        }}</span>
                                </div>
                                <div class="w-full mt-4 m-auto upload-image">
                                    <vue-upload-multiple-image @upload-success="uploadImageSuccess"
                                                               @before-remove="beforeRemove" @edit-image="editImage"
                                                               @data-change="dataChange"
                                                               :data-images="images"></vue-upload-multiple-image>
                                </div>
                            </div>
                        </div>

                        <vs-divider class="mt-8 mb-0"/>

                        <div class="flex items-end mt-8 mb-3">
                            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-6 h-6"/>
                            <span class="leading-none fsz font-bold">Địa chỉ</span>
                        </div>

                        <!-- Content Row -->

                        <div class="vx-row">
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <vs-input class="w-full" :label="$t('menuOrganization.phoneNumber')"
                                          v-model="employeeInfo.phoneNumber"
                                          v-validate="{regex: /(0[3|5|7|8|9])+([0-9]{8})\b/, numeric: true}"
                                          name="phoneNumber"/>
                                <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.city') }}</label>
                                <span class="text-danger">*</span>
                                <v-select class="" v-model="province" :clearable="false" :options="cityOptions"
                                          data-vv-validate-on="blur" v-validate="'required'" name="organizationType">
                                    <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors.first('city') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.district') }} </label>
                                <span class="text-danger">*</span>
                                <v-select class="" v-model="district" :clearable="false" :options="districtOptions"
                                          data-vv-validate-on="blur" v-validate="'required'" name="organizationType">
                                    <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors.first('district') }}</span>
                            </div>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.commune') }} </label>
                                <span class="text-danger">*</span>
                                <v-select class="" v-model="subDistrict" :clearable="false"
                                          :options="subDistrictOptions"
                                          data-vv-validate-on="blur" v-validate="'required'" name="organizationType">
                                    <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors.first('subDistrict') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.houseNumber') }} </label>
                                <span class="text-danger">*</span>
                                <vs-input class="w-full" v-model="employeeInfo.houseNumber"
                                          v-validate="'required|max:100'"
                                          name="houseNumber"/>
                                <span class="text-danger text-sm">{{ errors.first('houseNumber') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <vs-input class="w-full" :label="$t('menuOrganization.address')"
                                          v-model="fullAddressModel"
                                          v-validate="''" name="full_address" readonly="true"/>
                            </div>
                        </div>

                        <vs-divider class="mt-8 mb-0"/>

                        <div class="vx-row">
                            <h3 class="ml-2 mt-6">{{ $t('menuOrganization.workingTime') }}</h3>
                        </div>
                        <div class="vx-row md:mb-1 mb-4 mt-4" v-for="(item, index) in workShiftSetting" :key="index">
                            <div class="vx-col lg:w-1/2 w-full">
                                <vs-checkbox v-model="item.select" class="mb-1">{{
                                        item.displayWorkShift
                                    }}
                                </vs-checkbox>
                            </div>
                            <!-- <div class="vx-col lg:w-1/2 w-full">
                              <div>{{item.displayWorkShift}}</div>
                            </div> -->
                            <div class="vx-col lg:w-1/4 w-full">
                                <vs-checkbox v-model="item.autoGenerateWorkShift" class="mb-1">{{
                                        $t('menuOrganization.autoGenerate')
                                    }}
                                </vs-checkbox>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->
                        <div class="vx-row" v-if="!employeeId">
                            <div class="vx-col w-full">
                                <div class="flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                                               v-if="(isUpdate && isPermissionEdit) || (!isUpdate && isPermissionAddEmployee)">
                                        {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                                    </vs-button>
                                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="employeeList">
                                        {{ $t('button.back') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <my-upload field="img" v-model="showUploadImage" @crop-success="cropSuccess" :width="300"
                               :height="300"
                               img-format="png" :langExt="ext">
                    </my-upload>
                </vs-tab>
                <!-- <vs-tab :label="$t('menuOrganization.authority')" v-if="isPermissionEdit()">
                    <div class="mt-3">
                        <v-jstree :data="permissions" show-checkbox multiple allow-batch whole-row
                            @item-click="itemClick"></v-jstree>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="flex flex-wrap items-center justify-end">
                                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                        `${isUpdate ?
                                            $t('button.update') : $t('button.create')}`
                                }}
                                </vs-button>
                                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="employeeList">
                                    {{ $t('button.back') }}
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </vs-tab> -->

                <vs-tab :label="$t('menuOrganization.rePass')" v-if="isPermissionEdit && isUpdate">
                    <div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.branch') }}</label>
                                <v-select class="" v-model="branchModel" :clearable="false" :options="branchOptions"
                                          data-vv-validate-on="blur" :disabled="isUpdate" v-validate="'required'"
                                          name="branch">
                                    <span slot="no-options"> {{ $t('menuNewsEvent.noRowsToShow') }} </span>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                            </div>
                            <div class="vx-col md:w-1/3 w-full mt-2">
                                <vs-input class="w-full" :label="$t('menuOrganization.employeeCode')"
                                          :disabled="isUpdate"
                                          v-model="employeeInfo.employeeCode" v-validate="'required'"
                                          name="employeeCode"/>
                                <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                            </div>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col md:w-2/3 w-full mt-2">
                                <vs-button v-if="activeIconEyeNewPassWord" type="flat" class="float-right mt-6"
                                           icon="icon-eye" icon-pack="feather" icon-no-border button-no-border
                                           @click="HiddenShowNewPassWord" style="margin-left: -68px"></vs-button>
                                <vs-button v-if="activeIconEyeOffNewPassWord" type="flat" class="float-right mt-6"
                                           icon="icon-eye-off" icon-pack="feather" icon-no-border
                                           @click="HiddenShowNewPassWord"
                                           style="margin-left: -68px"></vs-button>
                                <vs-input class="w-full" :label="$t('menuOrganization.newPass')" v-model="newPassword"
                                          :type="typeOptionNewPassWord" v-validate="'required'" name="newPassword"/>
                                <span class="text-danger text-sm">{{ errors.first('newPassword') }}</span>
                            </div>
                            <div class="vx-col w-full mt-2">
                                <div class="flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-auto mt-2" @click="changePassword" :disabled="!validateForm">{{
                                            `${isUpdate ?
                                                $t('button.update') : $t('button.create')}`
                                        }}
                                    </vs-button>
                                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="employeeList">
                                        {{ $t('button.back') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import province from '@/assets/utils/province.js';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale'
import utils from "../../../../components/utils";
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage'
import VJstree from 'vue-jstree';
import moment from "moment";
import myUpload from 'vue-image-crop-upload'
import {isAPI} from '../../../../store/permission';
import {constAPI} from '../../../../store/constant';
import {authConfig, cdnImage} from '@/../auth_config.json';

export default {
    components: {
        vSelect,
        Datepicker,
        VueUploadMultipleImage,
        VJstree,
        'my-upload': myUpload
    },
    props: {
        employeeId: {
            type: Number,
            default: null,
        },
        branch_id: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            isMaxLength: false,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                from: this.setDateRange()
            },
            en: en,
            vn: vi,
            departmentName: null,
            isCreateDepartment: false,
            isShowManagerDepartment: false,
            departmentOptions: [],
            isShowPermission: false,
            // permissions: [],
            privileges: [],
            images: [],
            imagesId: [],
            isUpdateImages: false,
            user_data: null,
            username: '',
            activeTab: 0,
            isUpdate: false,
            isUpdateFace: false,
            branchOptions: [],
            employeeInfo: {},
            workShiftSetting: [],
            timeSpans: [],
            newPassword: null,
            genderOptions: [
                {value: 0, label: this.$t('genderOption.unknown')},
                {value: 1, label: this.$t('genderOption.male')},
                {value: 2, label: this.$t('genderOption.female')}
            ],
            employeeTypeOptions: [
                {value: 0, label: this.$t('employeeTypeOptions.unknown')},
                {value: 1, label: this.$t('employeeTypeOptions.trainee')},
                {value: 2, label: this.$t('employeeTypeOptions.officialStaff')}
            ],
            cityOptions: province.getProvince(),
            districtOptions: [],
            subDistrictOptions: [],
            file: [],
            fileName: this.$t('menuOrganization.addFace'),
            uploadPercent: 0,
            activeIconEyeNewPassWord: true,
            activeIconEyeOffNewPassWord: false,
            typeOptionNewPassWord: 'password',
            showEdit: false,
            ext: {
                hint: 'Chọn ảnh cập nhật',
                loading: 'Đang cập nhật...',
                noSupported: 'Trình duyệt không hỗ trợ',
                primary: 'Cập nhật thành công',
                fail: 'Cập nhật thất bại',
                preview: 'Xem trước',
                btn: {
                    off: 'Hủy',
                    close: 'Đóng',
                    back: 'Quay lại',
                    save: 'Cập nhật'
                },
                error: {
                    onlyImg: 'Chỉ được đăng tải định dạng là ảnh',
                    outOfSize: 'Ảnh tải lên vượt quá dung lượng cho phép',
                    lowestPx: 'Ảnh tải lên dung lượng quá thấp.'
                }
            },
            userInfo: {
                avatar: require("@/assets/images/portrait/small/user-avatar.png"),
                img: null
            },
            showUploadImage: false,
            img: null,
            positionOptions: [],
            selectedPositions: null,
            dutyOptions: [
                {value: '1', label: 'Trưởng phòng'},
                {value: '2', label: 'Phó phòng'},
                {value: '3', label: 'Bác sĩ'},
                {value: '4', label: 'Phụ tá'},
                {value: '5', label: 'Lễ tân'},
                {value: '6', label: 'Bảo vệ'},
                {value: '7', label: 'CSKH'},
                {value: '8', label: 'Khác'},
            ],
            selectedDutyValue: null,
            selectedDutyInputValue: null,
        }
    },
    async created() {
        this.showUploadImage = false;
        // this.cityOptions.unshift({value: null, label: 'Tất cả'});
        // this.districtOptions.unshift({value: null, label: 'Tất cả'});
        // this.subDistrictOptions.unshift({value: null, label: 'Tất cả'});
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.employeeInfo = {
            organizationBranchName: null,
            username: '',
            city: null,
            district: null,
            fullAddress: null,
            houseNumber: null,
            organizationBranchType: 0,
            organizationBranchId: this.$route.query.branch_id ? this.$route.query.branch_id : this.branch_id,
            phoneNumber: null,
            street: null,
            gender: 0,
            type: 0,
            salary: 0,
            departmentId: null,
            departmentType: 0,
            enabled: true,
            firstName: null,
            lastName: null,

        };
        await this.getPositions()
        await this.getDepartment();
        await this.loadWorkShiftSetting();
        let employeeId = this.$route.query.id ? this.$route.query.id : this.employeeId;

        // this.getInfo();
        if (employeeId) {
            this.isUpdate = true;
            await this.getUserInfo(employeeId);
            for (const x of this.employeeInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file
                });
            }
        }

        let imageUrl = this.$route.query.imageUrl
        if (imageUrl) {
            this.employeeInfo.imageStore = authConfig.processorDomain + "storage/" + imageUrl
            let data = await this.toDataURL(this.employeeInfo.imageStore);
            let dataImage = data.xhr.response;
            let metadata = {
                type: 'image/jpeg'
            };
            let file = new File([dataImage], "avatar", metadata);
            this.images.push({
                name: "avatar",
                path: data.imgBase64,
                highlight: 1,
                default: 1,
                file: file
            });
        }
    },
    computed: {
        firstNameModel: {
            get() {
                return this.employeeInfo.firstName;
            },
            set(value) {
                this.employeeInfo.firstName = value;
                if (!this.isUpdate) this.changValueUserName();
            }
        },
        lastNameModel: {
            get() {
                return this.employeeInfo.lastName;
            },
            set(value) {
                this.employeeInfo.lastName = value;
                if (!this.isUpdate) this.changValueUserName();
            }
        },
        branchModel: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.employeeInfo.organizationBranchId)),
                    value: this.employeeInfo.organizationBranchId,
                }
            },
            set(obj) {
                this.employeeInfo.organizationBranchId = obj.value;
                this.loadWorkShiftSetting()
                this.getDepartment();
            }
        },
        departmentModel: {
            get() {
                return {
                    label: this.getLabelString(this.departmentOptions.find(x => x.value === this.employeeInfo.departmentId)),
                    value: this.employeeInfo.departmentId
                }
            },
            set(obj) {
                this.employeeInfo.departmentId = obj.value;
                this.employeeInfo.departmentType = false;
                this.isShowManagerDepartment = !!this.employeeInfo.departmentId;
            }
        },
        validateForm() {
            return !this.errors.any()
        },
        genderModel: {
            get() {
                return {
                    label: this.genderOptions.find(x => x.value === this.employeeInfo.gender).label,
                    value: this.employeeInfo.gender
                }
            },
            set(obj) {
                this.employeeInfo.gender = obj.value;
            }
        },
        employeeTypeModel: {
            get() {
                return {
                    label: this.employeeTypeOptions.find(x => x.value === this.employeeInfo.type).label,
                    value: this.employeeInfo.type
                }
            },
            set(obj) {
                this.employeeInfo.type = obj.value;
            }
        },
        province: {
            get() {
                return {
                    label: this.getLabelString(this.cityOptions.find(x => x.value === this.employeeInfo.city)),
                    value: this.employeeInfo.city
                }
            },
            set(obj) {
                if (obj.value) {
                    this.employeeInfo.city = obj.value;
                    this.districtOptions = province.getDistrict(obj.value);
                    this.employeeInfo.district = this.districtOptions[0].value;
                    this.subDistrictOptions = province.getSubDistrict(this.employeeInfo.city, this.employeeInfo.district);
                    this.employeeInfo.street = this.subDistrictOptions[0].value;
                } else {
                    this.employeeInfo.city = null;
                    this.districtOptions = [{value: null, label: 'Tất cả'}];
                    this.employeeInfo.district = null;
                    this.subDistrictOptions = [{value: null, label: 'Tất cả'}];
                    this.employeeInfo.street = null;
                }
            }
        },
        district: {
            get() {
                return {
                    label: this.getLabelString(this.districtOptions.find(x => x.value === this.employeeInfo.district)),
                    value: this.employeeInfo.district
                }
            },
            set(obj) {
                this.employeeInfo.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.employeeInfo.city, obj.value);
                this.employeeInfo.street = this.subDistrictOptions[0].value;
            }
        },
        subDistrict: {
            get() {
                return {
                    label: this.getLabelString(this.subDistrictOptions.find(x => x.value === this.employeeInfo.street)),
                    value: this.employeeInfo.street
                }
            },
            set(obj) {
                this.employeeInfo.street = obj.value
            }
        },

        fullAddressModel: {
            get() {
                if (this.province.value) {
                    let fullAddress = `${this.employeeInfo.houseNumber ? this.employeeInfo.houseNumber + ', ' : ''}${this.subDistrict.label ? this.subDistrict.label + ', ' : ''}${this.district.label}, ${this.province.label}`;
                    this.employeeInfo.fullAddress = fullAddress;
                    return fullAddress;
                } else if (!this.province.value && this.isUpdate) {
                    return this.employeeInfo.fullAddress;
                } else {
                    return null;
                }
            },
        },

        userNameModel: {
            get() {
                return this.employeeInfo.username;
            },
            set(val) {
                this.employeeInfo.username = val;
            }
        },

        selectedDuty: {
            get() {
                let obj = this.dutyOptions.find(x => x.value == this.selectedDutyValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDutyValue = obj ? obj.value : null;
            }
        }
    },

    watch: {},

    methods: {
        isPermissionEdit() {
            return isAPI(this, constAPI.employee_edit);
        },
        isPermissionAddEmployee() {
            return isAPI(this, constAPI.employee_add);
        },
        getPositions() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$oauth.get('/position/find-all').then((response) => {
                    this.positionOptions = response.data.map(el => {
                        return {
                            value: el.id,
                            label: el.name
                        }
                    });
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                    });
                });
            })
        },

        // eslint-disable-next-line no-unused-vars
        cropSuccess: function (e, fileInput) {
            const payload = {
                image: e
            }
            this.$oauth.post('/user/update-avatar', payload).then(() => {
                this.$eventBus.$emit('update-avatar', true);
                // this.getInfo();
                return this.$vs.notify({
                    text: 'Cập nhật ảnh đại diện thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                })
            })
        },
        editAvatar: function () {
            // this.showUploadImage = true;
        },
        setDateRange() {
            return new Date();
        },
        checkLengthUserName() {
            if (this.userNameModel.length > 50) {
                this.isMaxLength = true
                this.userNameModel = this.userNameModel.trim();
            } else {
                this.isMaxLength = false
                this.userNameModel = this.userNameModel.trim();
            }
        },
        changValueUserName: function () {
            let username = `${this.employeeInfo.firstName ? this.employeeInfo.firstName : ''}`
            const lastNames = this.employeeInfo.lastName.split(' ');
            lastNames.forEach(item => {
                username += item.substr(0, 1)
            });
            this.employeeInfo.username = username
                .split(' ')
                .join('')
                .replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, "a")
                .replace(/[èéẹẻẽêềếệểễ]/g, "e")
                .replace(/[ìíịỉĩ]/g, "i")
                .replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, "o")
                .replace(/[ùúụủũưừứựửữ]/g, "u")
                .replace(/[ỳýỵỷỹ]/g, "y")
                .replace(/đ/g, "d")
                .replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, "A")
                .replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, "E")
                .replace(/[ÌÍỊỈĨ]/g, "I")
                .replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, "O")
                .replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, "U")
                .replace(/[ỲÝỴỶỸ]/g, "Y")
                .replace(/Đ/g, "D")
                .replace(/[\u0300\u0301\u0303\u0309\u0323]/g, "")
                .replace(/[\u02C6\u0306\u031B]/g, "")
                // eslint-disable-next-line no-useless-escape
                .replace(/[!@%^*()+=<>?\/,.:;'"&#\[\]~$_`\-{}|\\]/g, " ")
                .trim()
                .toLowerCase();
        },
        HiddenShowNewPassWord() {
            this.activeIconEyeOffNewPassWord = !this.activeIconEyeOffNewPassWord
            if (this.typeOptionNewPassWord == 'password') {
                this.typeOptionNewPassWord = 'text'
            } else {
                this.typeOptionNewPassWord = 'password'
            }
        },
        async changePassword(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            // eslint-disable-next-line no-useless-escape
            let vietnameseRegex = /[^\w#_@]/g
            if (this.newPassword.length < 6) {
                return this.$vs.notify({
                    text: 'Mật khẩu phải chứa ít nhất 6 kí tự.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if (vietnameseRegex.test(this.newPassword)) {
                return this.$vs.notify({
                    text: 'Mật khẩu không được tồn tại khoảng cách và dấu',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            const result = await this.$validator.validateAll();
            if (!result) return;

            this.$vs.loading()
            let url = "/user/org-reset-password";
            this.$oauth.post(url, null, {
                params: {
                    employeeCode: this.employeeInfo.employeeCode,
                    password: this.newPassword,
                }
            }).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'success',
                    text: `Thay đổi mật khẩu thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.push(`/user/manage-employee${this.password ?
                    `?branch_id=${this.password}` : ''}`).catch(() => {
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        checkUserName(check) {
            this.$vs.loading()
            this.$oauth.get(`/user/check-username?username=${this.employeeInfo.username}`).then((response) => {
                if (response.data !== true) {
                    if (check) {
                        this.$vs.notify({
                            color: 'success',
                            text: this.$t('menuOrganization.validUsername'),
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                    }
                } else {
                    this.$vs.notify({
                        color: 'danger',
                        text: this.$t('menuOrganization.userExists'),
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                }
                this.$vs.loading.close();
            })
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },
        getUserInfo(employeeId) {
            return new Promise(resolve => {
                this.$vs.loading();
                this.$crm.post('/employee/find-by-id/' + employeeId).then(async (response) => {
                    if (response.data.departmentDTO) {
                        response.data.departmentId = response.data.departmentDTO.id;
                        this.isShowManagerDepartment = true;
                    } else {
                        response.data.departmentId = null;
                    }
                    delete response.data.departmentDTO;
                    if (response.data.positions) {
                        let result = this.positionOptions.map(el => {
                            let p = response.data.positions.find(t => t === el.value)
                            if (p) {
                                return {
                                    value: p,
                                    label: el.label
                                }
                            }
                        })
                        this.selectedPositions = result.filter(t => t);
                    }
                    this.employeeInfo = response.data;
                    if (response.data.avatar && response.data.avatar.includes('infocare')) {
                        this.img = this.employeeInfo.avatar.replace('cdn.infocare', 'cdnimage.inviv');
                    } else {
                        this.img = this.employeeInfo.avatar;
                    }
                    let checkValuePosition = response.data.position;
                    if ([1, 2, 3, 4, 5, 6, 7].includes(parseInt(checkValuePosition, 10))) {
                        this.selectedDutyValue = checkValuePosition;
                    } else {
                        this.selectedDutyValue = '8';
                        this.selectedDutyInputValue = checkValuePosition;
                    }
                    if (this.employeeInfo && !this.employeeInfo.username) this.changValueUserName();
                    this.districtOptions = province.getDistrict(this.employeeInfo.city);
                    this.subDistrictOptions = province.getSubDistrict(this.employeeInfo.city, this.employeeInfo.district);
                    if (Array.isArray(this.employeeInfo.workShiftSetting)) {
                        this.workShiftSetting.forEach(item => {
                            let setting = this.employeeInfo.workShiftSetting.find(setting => {
                                return item.id === setting.workShiftSettingId;
                            })
                            if (setting) {
                                item.select = true;
                                item.autoGenerateWorkShift = setting.autoGenerateWorkShift;
                            } else {
                                item.select = false
                                item.autoGenerateWorkShift = false;
                            }
                        })
                    }
                    resolve(true);
                    this.$vs.loading.close();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        createDepartment() {
            this.employeeInfo.departmentId = null;
            this.isShowManagerDepartment = false;
            this.departmentName = null;
            this.isCreateDepartment = true;
        },
        saveDepartment() {
            if (!this.departmentName) {
                return this.$vs.notify({
                    text: this.$t('menuOrganization.cannotName'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            let dataRequest = {
                departmentName: this.departmentName,
                organizationBranchId: this.employeeInfo.organizationBranchId
            }
            this.$vs.loading();
            this.$crm.post('/department/create', dataRequest).then((response) => {
                this.isCreateDepartment = false;
                this.getDepartment();
                setTimeout(() => {
                    this.departmentModel = {value: response.data.id, label: response.data.departmentName};
                    this.$vs.notify({
                        color: 'success',
                        text: `${this.$t('warningMenuOrganization.newDepartments')} ${this.departmentName} ${this.$t('warningMenuOrganization.success')}`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                }, 200)
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        cancelCreateDeparment() {
            this.isCreateDepartment = false;
        },

        getDepartment() {
            this.$vs.loading();
            let searchInfo = {
                organizationBranchId: parseInt(this.employeeInfo.organizationBranchId)
            }
            this.$crm.post('/department/find-by-condition', searchInfo).then((response) => {
                this.departmentOptions = response.data.map(x => {
                    return {
                        value: x.id,
                        label: x.departmentName
                    }
                });
                this.departmentOptions.unshift({value: null, label: this.$t('employeeTypeOptions.unknown')});
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        // getAllPermission(arrPermissions) {
        //     return new Promise(resolve => {
        //         this.$vs.loading();
        //         this.$oauth.get('/permission').then((response) => {
        //             this.$vs.loading.close();
        //             let permissions = response.data.reduce((groups, item) => {
        //                 const group = (groups[item.aliasGroupName] || []);
        //                 group.push(item);
        //                 groups[item.aliasGroupName] = group;
        //                 return groups;
        //             }, {});
        //             for (const property in permissions) {
        //                 let permission = {
        //                     text: property,
        //                     children: [],
        //                     icon: "fa fa-warning icon-state-danger",
        //                     opened: true,
        //                 }
        //                 permissions[property].forEach(value => {
        //                     value.text = value.aliasName;
        //                     value.icon = "fa fa-warning icon-state-danger";
        //                     value.opened = true;
        //                     if (arrPermissions) {
        //                         arrPermissions.filter(x => {
        //                             if (x == value.name) {
        //                                 value.selected = true;
        //                                 this.privileges.push(value.id);
        //                             }
        //                         })
        //                     }
        //                     permission.children.push(value);
        //                 })
        //                 let selectedFullChild = 0;
        //                 permission.children.forEach(x => {
        //                     if (x.selected == true) selectedFullChild++;
        //                 })
        //                 if (permission.children.length == selectedFullChild) permission.selected = true;
        //                 this.permissions.push(permission);
        //             }
        //             resolve(true);
        //         });
        //     })
        // },
        itemClick(node) {
            if (node.data.children && node.data.children.length > 0) {
                if (node.data.selected) {
                    node.data.children.forEach(x => {
                        let privilege = this.privileges.find(privilege => privilege === x.id);
                        if (!privilege) this.privileges.push(x.id);
                    })
                } else {
                    node.data.children.forEach(x => {
                        this.privileges = this.privileges.filter(privilege => privilege !== x.id);
                    })
                }
            } else {
                if (node.data.selected) {
                    this.privileges.push(node.data.id);
                } else {
                    this.privileges = this.privileges.filter(x => x !== node.data.id);
                }
            }
        },
        // eslint-disable-next-line no-unused-vars
        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuOrganization.null');
        },
        manufactureString(type) {
            let typeString = this.manufactureOptions.find(x => x.value === type);
            return (typeString && typeString.label) || this.$t('menuOrganization.null');
        },
        loadWorkShiftSetting() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/work-shift/organization/find-by-organization-branch/' + this.employeeInfo.organizationBranchId).then((response) => {
                    this.workShiftSetting = response.data.workShiftSetting.map(item => {
                        if (this.isUpdate) {
                            let setting = this.employeeInfo.workShiftSetting.find(setting => {
                                return item.id === setting.workShiftSettingId;
                            })
                            if (setting) {
                                item.select = true;
                                item.autoGenerateWorkShift = setting.autoGenerateWorkShift;
                            } else {
                                item.select = false
                                item.autoGenerateWorkShift = false;
                            }
                        } else {
                            item.select = true;
                            item.autoGenerateWorkShift = true;
                        }
                        item.displayWorkShift = "Nhóm " + item.groupName + " - Ca " + item.name + ": " + utils.minuteToHour(item.startHour) + "-" + utils.minuteToHour(item.endHour);
                        return item;
                    });
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: this.$t('message.error'),
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            if (!this.employeeInfo.employeeCode) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('employeeScreen.requiredEmployeeId'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.firstName || this.employeeInfo.firstName == '') {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('employeeScreen.requiredFirstName'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.lastName || this.employeeInfo.lastName == '') {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('employeeScreen.requiredLastName'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.username || this.employeeInfo.username == '') {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('employeeScreen.requiredUsername'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.birthday) {
                return this.$vs.notify({
                    title: this.$t('employeeScreen.requiredBirth'),
                    text: this.$t('menuOrganization.theFuture'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.email || this.employeeInfo.email == '') {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('employeeScreen.requiredEmail'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            } else if (!this.employeeInfo.houseNumber) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('employeeScreen.requiredStreet'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if (this.isUpdate && this.images.length === 0) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('employeeScreen.requiredImage'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }


            if (new Date(this.employeeInfo.birthday).getTime() > new Date().getTime()) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('menuOrganization.theFuture'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if (!this.employeeInfo.city) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('menuOrganization.geolocation'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }

            // let checkUsername = this.checkUserName(false);
            // if (checkUsername) return;
            this.employeeInfo.workShiftSetting = this.workShiftSetting.reduce((arr, item) => {
                if (item.select) {
                    arr.push({
                        workShiftSettingId: item.id,
                        autoGenerateWorkShift: item.autoGenerateWorkShift ? 1 : 0
                    });
                }
                return arr;
            }, []);

            this.employeeInfo.fullName = this.employeeInfo.firstName.trim() + " " + this.employeeInfo.lastName.trim();
            this.employeeInfo.privileges = this.privileges;

            if (this.employeeInfo.departmentType) {
                this.employeeInfo.departmentType = 1
            } else {
                this.employeeInfo.departmentType = 0;
            }

            if (this.images.length !== 0 && !this.isUpdate || this.isUpdate && this.isUpdateImages) {
                await this.handleClickUploadFile();
                this.employeeInfo.images = this.imagesId;
            }
            if (this.selectedPositions) {
                this.employeeInfo.positions = this.selectedPositions.map(x => {
                    let obj
                    obj = x.value
                    return obj
                })
            }

            if (this.selectedDutyInputValue && this.selectedDutyValue == 8) {
                let checkPosition = this.dutyOptions.find(x => x.label.replace(/\s/g, "").toLowerCase() == this.selectedDutyInputValue.replace(/\s/g, "").toLowerCase())
                if (checkPosition) {
                    return this.$vs.notify({
                        text: 'Vị trí khác không được trùng với vị trí đã có!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            }
            this.employeeInfo.position = this.selectedDutyValue == 8 ? this.selectedDutyInputValue : this.selectedDutyValue;

            this.$vs.loading()
            let url = this.isUpdate ? `/employee/update/${this.employeeInfo.employeeId}` : `/employee/create-single/${this.employeeInfo.organizationBranchId}`;

            let formData = new FormData(), config = {};
            config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            };
            const blob = new Blob([JSON.stringify(this.employeeInfo)], {type: 'application/json'});
            formData.append('dto', blob);
            this.$crm.post(url, formData, config).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('button.update') : this.$t('button.create')} ${this.$t('menuOrganization.succPersonnel')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.push(`/user/manage-employee`).catch(() => {
                })
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmHandleClickUploadFile() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('button.titleDelete'),
                text: this.$t('menuOrganization.oldData'),
                accept: this.handleClickUploadFile,
                acceptText: this.$t('statusActive.agree'),
                cancelText: this.$t('statusActive.cancel')
            })
        },
        handleClickUploadFile() {
            return new Promise((resolve) => {
                let formData = new FormData(), config;
                if (this.isUpdate) formData.append('employeeId', this.employeeInfo.employeeId)
                this.images.forEach((f, i) => {
                    formData.append('files', f.file);
                });
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };
                this.$vs.loading();
                this.$crm.post('/employee/image/upload', formData, config).then((res) => {
                    this.imagesId = [];
                    this.imagesId = res.data;
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },
        employeeList() {
            this.$router.push(`/user/manage-employee${this.employeeInfo.organizationBranchId ? `?branch_id=${this.employeeInfo.organizationBranchId}` : ''}`).catch(() => {
            })
        }
    },
}
</script>

<style lang="scss">
.upload-image {
    width: 200px !important;
}

.custom-edit {
    margin-top: -60% !important;
    opacity: 0.7;
    border-radius: 50%;
    border: 1px solid #ffffff;
    width: 30px;
    height: 30px;
}
</style>
